var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "chat-input-container",
      style: {
        margin: _vm.isFullScreen() ? "0 0 16px 0" : "0 24px 16px 24px",
      },
      on: { mousedown: _vm.allowTextSelection, keydown: _vm.handleKeyupDiv },
    },
    [
      !_vm.getIsAIEnd()
        ? _c(
            "div",
            {
              class: {
                "stop-out": true,
                "stop-out-full": _vm.isFullScreen(),
                "stop-out-ImageGeneration":
                  (_vm.getIsShowImageGeneration ||
                    _vm.getIsShowDouyinBZhangGuide) &&
                  _vm.isFullScreen(),
              },
              on: { click: _vm.stopAIOut },
            },
            [
              _c("img", {
                staticClass: "stop-icon",
                attrs: {
                  src: require("@/assets/image/aigc/stop-out.png"),
                  alt: "",
                },
              }),
              _c("img", {
                staticClass: "stop-icon-hover",
                attrs: {
                  src: require("@/assets/image/aigc/stop-out-hover.png"),
                  alt: "",
                },
              }),
              _c("span", [_vm._v("停止输出")]),
            ]
          )
        : _vm._e(),
      _vm.isShowFileUploadShow()
        ? _c(
            "div",
            { staticClass: "file-upload-show" },
            [
              _vm.fileList[0].type.includes("image")
                ? _c(
                    "div",
                    { staticClass: "img-box" },
                    [
                      _vm.fileLoding
                        ? _c("div", { staticClass: "mask" }, [
                            _c("img", {
                              staticClass: "loading",
                              attrs: {
                                src: require("@/assets/svg/file/loading.svg"),
                              },
                            }),
                          ])
                        : _vm._e(),
                      _c("img", {
                        staticClass: "upload-image no-drag",
                        attrs: { src: _vm.fileImageUrl },
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "不再围绕该文件提问",
                            placement: "top",
                            "popper-class": "custom-zyq-prpper",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "del-icon no-drag",
                            attrs: {
                              src: require("@/assets/svg/file/guanbi-file.svg"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDeleteFileClick(0)
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._l(_vm.fileList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "file-card" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: "不再围绕该文件提问",
                              placement: "top",
                              "popper-class": "custom-zyq-prpper",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "del-icon no-drag",
                              attrs: {
                                src: require("@/assets/svg/file/guanbi-file.svg"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteFileClick(index)
                                },
                              },
                            }),
                          ]
                        ),
                        _c("div", { staticClass: "file-icon no-drag" }, [
                          _vm.fileLoding
                            ? _c("div", { staticClass: "mask" }, [
                                _c("img", {
                                  staticClass: "loading",
                                  attrs: {
                                    src: require("@/assets/svg/file/loading.svg"),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _c("img", {
                            staticClass: "icon no-drag",
                            attrs: {
                              src: require(`@/assets/svg/file/${_vm.fileExtension}.svg`),
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "file-info" }, [
                          _c("div", { staticClass: "file-title" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm.fileLoding
                            ? _c("span", { staticClass: "file-status" }, [
                                _vm._v("上传中"),
                              ])
                            : _vm._e(),
                          !_vm.fileLoding &&
                          _vm.fileLoadingStatus !== "COMPLETED"
                            ? _c("span", { staticClass: "file-status" }, [
                                _vm._v("上传失败"),
                              ])
                            : _vm._e(),
                          !_vm.fileLoding &&
                          _vm.fileLoadingStatus === "COMPLETED"
                            ? _c("span", { staticClass: "file-detail" }, [
                                _vm._v(
                                  _vm._s(_vm.fileExtension) +
                                    " " +
                                    _vm._s(_vm.getfilesize(item.size))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  }),
            ],
            2
          )
        : _vm._e(),
      _vm.isShowFileUploadShow()
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  display: "flex",
                  "align-items": "flex-end",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "highlight-wrapper",
                    class: { "use-highlight": _vm.useHighlight },
                    staticStyle: { position: "relative", flex: "1" },
                  },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.useHighlight,
                          expression: "useHighlight",
                        },
                      ],
                      staticClass: "highlight-preview",
                      domProps: { innerHTML: _vm._s(_vm.highlightedChatValue) },
                    }),
                    _vm.isShowInput
                      ? _c("el-input", {
                          ref: "chatInputRefs",
                          staticStyle: { border: "none", width: "100%" },
                          attrs: {
                            id: "chat-input",
                            type: "textarea",
                            placeholder: _vm.getPleaceholder,
                            resize: "none",
                            maxlength: _vm.chatValueLimit,
                            autosize: { minRows: 1, maxRows: 10 },
                            disabled: _vm.getDisabledInput(),
                          },
                          on: { input: _vm.handleChangeInput },
                          nativeOn: {
                            keydown: function ($event) {
                              return _vm.handleKeyup.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.chatValue,
                            callback: function ($$v) {
                              _vm.chatValue = $$v
                            },
                            expression: "chatValue",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "flex input-bottom flex-between" }, [
                  _c("div", { staticStyle: { "margin-left": "14px" } }, [
                    _vm.getIsShowDouyinBZhangGuide
                      ? _c(
                          "span",
                          {
                            ref: "msgUrlId",
                            staticClass: "msg-url",
                            on: { click: _vm.openGuide },
                          },
                          [
                            _vm._v(" 网站快捷入口： "),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(2)
                                  },
                                },
                              },
                              [_vm._v(" B站 ")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(1)
                                  },
                                },
                              },
                              [_vm._v(" 抖音 ")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(3)
                                  },
                                },
                              },
                              [_vm._v(" 小红书 ")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(4)
                                  },
                                },
                              },
                              [_vm._v(" 快手 ")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(5)
                                  },
                                },
                              },
                              [_vm._v(" 微博 ")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "highlight-span pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.onhandleOpenThirdWeb(6)
                                  },
                                },
                              },
                              [_vm._v(" 今日头条 ")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      style: {
                        marginLeft: _vm.isFullScreen() ? "16px" : "8px",
                        gap: _vm.isFullScreen() ? "12px" : "8px",
                      },
                    },
                    [
                      _c("span", { staticClass: "chat-input-length" }, [
                        _vm._v(
                          _vm._s(_vm.chatValue.length) +
                            "/" +
                            _vm._s(_vm.chatValueLimit)
                        ),
                      ]),
                      _vm.orgInfo.organizationId !== 1000000
                        ? _c(
                            "label",
                            { attrs: { for: "file-upload-input" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.isEarth
                                      ? "联网搜索不支持上传文件"
                                      : "支持上传Word、Excel、PDF、PPT、音频、TXT、图片文件",
                                    placement: "top",
                                    "popper-class": "custom-zyq-prpper",
                                  },
                                },
                                [
                                  _vm.$store.state.ai.isScene.id === "1"
                                    ? _c("img", {
                                        staticStyle: {
                                          height: "24px",
                                          width: "24px",
                                        },
                                        attrs: {
                                          src: require("@/assets/image/aigc/Paperclip.png"),
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("input", {
                        staticStyle: { display: "none" },
                        attrs: {
                          id: "file-upload-input",
                          type: "file",
                          disabled: _vm.isEarth,
                        },
                        on: { change: _vm.handleFileUpload },
                      }),
                      (!_vm.chatValue && !_vm.fileList.length) || _vm.fileLoding
                        ? _c("img", {
                            staticStyle: { height: "26px", width: "26px" },
                            attrs: {
                              src: require("@/assets/image/aigc/icon_send_df.png"),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      (_vm.chatValue || _vm.fileList.length) && !_vm.fileLoding
                        ? _c("img", {
                            staticStyle: { height: "26px", width: "26px" },
                            attrs: {
                              src: require("@/assets/image/aigc/icon_send.png"),
                              alt: "",
                            },
                            on: { click: _vm.send },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        : [
            _c(
              "div",
              {
                staticClass: "highlight-wrapper",
                class: { "use-highlight": _vm.useHighlight },
                staticStyle: { position: "relative" },
              },
              [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.useHighlight,
                      expression: "useHighlight",
                    },
                  ],
                  staticClass: "highlight-preview",
                  domProps: { innerHTML: _vm._s(_vm.highlightedChatValue) },
                }),
                _vm.isShowInput
                  ? _c("el-input", {
                      ref: "chatInputRefs",
                      staticStyle: { border: "none" },
                      attrs: {
                        id: "chat-input",
                        type: "textarea",
                        placeholder: _vm.getPleaceholder,
                        resize: "none",
                        maxlength: _vm.chatValueLimit,
                        autosize: { minRows: 2, maxRows: 10 },
                        disabled: _vm.getDisabledInput(),
                      },
                      on: { input: _vm.handleChangeInput },
                      nativeOn: {
                        keydown: function ($event) {
                          return _vm.handleKeyup.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.chatValue,
                        callback: function ($$v) {
                          _vm.chatValue = $$v
                        },
                        expression: "chatValue",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "flex input-bottom flex-between" }, [
              _c("div", { staticStyle: { "margin-left": "16px" } }, [
                _vm.getIsShowDouyinBZhangGuide
                  ? _c(
                      "span",
                      {
                        ref: "msgUrlId",
                        staticClass: "msg-url",
                        on: { click: _vm.openGuide },
                      },
                      [
                        _vm._v(" 网站快捷入口： "),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(2)
                              },
                            },
                          },
                          [_vm._v(" B站 ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(1)
                              },
                            },
                          },
                          [_vm._v(" 抖音 ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(3)
                              },
                            },
                          },
                          [_vm._v(" 小红书 ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(4)
                              },
                            },
                          },
                          [_vm._v(" 快手 ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(5)
                              },
                            },
                          },
                          [_vm._v(" 微博 ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "highlight-span pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onhandleOpenThirdWeb(6)
                              },
                            },
                          },
                          [_vm._v(" 今日头条 ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.getisDeleted
                  ? _c("div", { staticClass: "model-operate" }, [
                      _c("span", { staticClass: "model-tip" }, [
                        _vm._v("切换模型"),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "select-wrapper",
                              style: {
                                marginRight: _vm.isFullScreen()
                                  ? "12px"
                                  : "8px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-display",
                                  class: { selected: _vm.modelType },
                                  style: {
                                    cursor: !_vm.getIsAIEnd()
                                      ? "not-allowed"
                                      : "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleCustomSelectClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getCurrentModelName)),
                                  ]),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down select-arrow",
                                    class: {
                                      "is-reverse": _vm.isDropdownVisible,
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  ref: "modelSelect",
                                  staticClass: "origin-select",
                                  attrs: {
                                    placeholder: "请选择",
                                    "popper-class": "model-select-popper",
                                  },
                                  on: {
                                    "visible-change": _vm.handleVisibleChange,
                                    change: _vm.handleChangeModel,
                                  },
                                  model: {
                                    value: _vm.modelType,
                                    callback: function ($$v) {
                                      _vm.modelType = $$v
                                    },
                                    expression: "modelType",
                                  },
                                },
                                _vm._l(_vm.getModelList(), function (item) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: item.llmType,
                                      attrs: {
                                        label: item.displayName,
                                        value: item.llmType,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "12px" },
                                        },
                                        [_vm._v(_vm._s(item.displayName))]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.getIsDeepSeek
                            ? [
                                !_vm.isFullScreen()
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "联网搜索",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "custom-display",
                                            class: { selected: _vm.isEarth },
                                            staticStyle: {
                                              "margin-left": "12px",
                                            },
                                            on: { click: _vm.handleEarth },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "14px",
                                                height: "14px",
                                              },
                                              attrs: {
                                                src: require(_vm.isEarth
                                                  ? "@/assets/image/aigc/Earth@2x.png"
                                                  : "@/assets/image/aigc/Earth_def.png"),
                                                alt: "",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "custom-display",
                                        class: { selected: _vm.isEarth },
                                        staticStyle: { "margin-left": "12px" },
                                        style: {
                                          padding: _vm.isFullScreen()
                                            ? "0 10px"
                                            : "0 8px",
                                        },
                                        on: { click: _vm.handleEarth },
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "14px",
                                            height: "14px",
                                          },
                                          attrs: {
                                            src: require(_vm.isEarth
                                              ? "@/assets/image/aigc/Earth@2x.png"
                                              : "@/assets/image/aigc/Earth_def.png"),
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              top: "1px",
                                            },
                                          },
                                          [_vm._v("联网搜索")]
                                        ),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex items-center",
                  style: {
                    marginLeft: _vm.isFullScreen() ? "16px" : "8px",
                    gap: _vm.isFullScreen() ? "12px" : "8px",
                  },
                },
                [
                  _c("span", { staticClass: "chat-input-length" }, [
                    _vm._v(
                      _vm._s(_vm.chatValue.length) +
                        "/" +
                        _vm._s(_vm.chatValueLimit)
                    ),
                  ]),
                  _vm.orgInfo.organizationId !== 1000000
                    ? _c(
                        "label",
                        { attrs: { for: "file-upload-input" } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.isEarth
                                  ? "联网搜索不支持上传文件"
                                  : "支持上传Word、Excel、PDF、PPT、音频、TXT、图片文件",
                                placement: "top",
                                "popper-class": "custom-zyq-prpper",
                              },
                            },
                            [
                              _vm.$store.state.ai.isScene.id === "1"
                                ? _c("img", {
                                    staticClass: "no-drag",
                                    staticStyle: {
                                      height: "24px",
                                      width: "24px",
                                    },
                                    attrs: {
                                      src: require("@/assets/image/aigc/Paperclip.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("input", {
                    staticStyle: { display: "none" },
                    attrs: {
                      id: "file-upload-input",
                      type: "file",
                      disabled: _vm.isEarth,
                    },
                    on: { change: _vm.handleFileUpload },
                  }),
                  !_vm.chatValue
                    ? _c("img", {
                        staticClass: "no-drag",
                        staticStyle: { height: "26px", width: "26px" },
                        attrs: {
                          src: require("@/assets/image/aigc/icon_send_df.png"),
                          alt: "",
                        },
                      })
                    : _c("img", {
                        staticClass: "no-drag pointer",
                        staticStyle: { height: "26px", width: "26px" },
                        attrs: {
                          src: require("@/assets/image/aigc/icon_send.png"),
                          alt: "",
                        },
                        on: { click: _vm.send },
                      }),
                ]
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }